
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, LookupItemViewModel } from "@tylertech/tyler-api-types";

/**
 * WorksiteLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class WorksiteLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<LookupItemViewModel[]>> {
        return this.$apiService.sendAuth("IWorksiteLookupService/Lookup", pCriteria);
    }
}
